// ---------------------------------------------
// auto-generated from materia/explica-player.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MSourceRail, MNotAdvice, MChart, MRail, MRenderModeSwitcher, MConceptGraph } from "./prims.jsx";
import { Icon, Eyebrow } from "../screens-cristal/primitives.jsx";

// ──────────────────────────────────────────────────────────
// Shared: Left panel "Mapa de conceptos" + acts list
// ──────────────────────────────────────────────────────────
export const ExplicaLeft = ({ act = 3 }) => {
  const nodes = [
    { k: "vela",    x: 30,  y: 50,  t: "Vela / OHLC", s: "done" },
    { k: "tend",    x: 30,  y: 110, t: "Tendencia", s: "done" },
    { k: "vol",     x: 30,  y: 170, t: "Volumen", s: "done" },
    { k: "sr",      x: 130, y: 90,  t: "S/R como zona", s: "now" },
    { k: "rupt",    x: 220, y: 70,  t: "Ruptura", s: "now" },
    { k: "false",   x: 220, y: 150, t: "Falsa ruptura", s: "now" },
    { k: "atr",     x: 230, y: 220, t: "ATR", s: "next" },
  ];
  const edges = [[0,3],[1,3],[2,3],[3,4],[3,5],[5,6,"dashed"],[4,6,"dashed"]];

  return (
    <div style={{ padding: 18, flex: 1, overflow: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <MEye>Mapa de conceptos</MEye>
        <button className="m-btn ghost sm" style={{ height: 22, padding: "0 6px", fontSize: 10 }}><Icon name="graph" size={10}/></button>
      </div>
      <div style={{ marginTop: 12, padding: 8, background: "rgba(0,0,0,0.25)", border: "1px solid var(--m-line)", borderRadius: 4 }}>
        <MConceptGraph nodes={nodes} edges={edges} focus="rupt" width={250} height={240}/>
      </div>

      <div className="m-divider" style={{ margin: "16px 0" }}/>

      <MEye>Estructura · 7 actos</MEye>
      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 4 }}>
        {[
          { a: "A1", t: "Hook · pregunta guía" },
          { a: "A2", t: "Modelo limpio" },
          { a: "A3", t: "Aplicación en chart" },
          { a: "A4", t: "Caso vivo" },
          { a: "A5", t: "Misconception lab" },
          { a: "A6", t: "Transferencia" },
          { a: "A7", t: "Recap" },
        ].map((b, i) => {
          const idx = i + 1;
          const state = idx < act ? "done" : idx === act ? "now" : "future";
          const c = state === "done" ? "var(--m-positive)" : state === "now" ? "var(--m-primary)" : "var(--m-text-mute)";
          return (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "6px 8px", borderRadius: 4,
              background: state === "now" ? "rgba(201,122,75,0.10)" : "transparent",
            }}>
              <span style={{
                width: 14, height: 14, borderRadius: 99,
                border: `1.5px solid ${c}`,
                background: state === "done" ? c : "transparent",
                flexShrink: 0,
              }}/>
              <span className="mono" style={{ width: 22, fontSize: 10, color: c }}>{b.a}</span>
              <span style={{ flex: 1, fontSize: 11.5, color: state === "future" ? "var(--m-text-3)" : "var(--m-text-2)" }}>{b.t}</span>
            </div>
          );
        })}
      </div>

      <div className="m-divider" style={{ margin: "16px 0" }}/>

      <MEye>Necesitas conocer</MEye>
      <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={{ fontSize: 11.5, color: "var(--m-text-2)" }}>◇ Soportes y resistencias (básico)</div>
        <div style={{ fontSize: 11.5, color: "var(--m-text-2)" }}>◇ Volumen básico</div>
      </div>
    </div>
  );
};

// Right panel: Tutor (default) ─────────────────────────────
export const ExplicaRight = ({ tab = "tutor" }) => (
  <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
    {/* tabs */}
    <div style={{ display: "flex", height: 38, borderBottom: "1px solid var(--m-line)", background: "var(--m-metal)" }}>
      {[
        { k: "tutor", i: "help", l: "Tutor" },
        { k: "source", i: "link", l: "Fuente" },
        { k: "gloss", i: "book", l: "Glosario" },
      ].map((t, i) => (
        <div key={i} style={{
          flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
          fontFamily: "var(--m-t-mono)", fontSize: 10.5, letterSpacing: "0.1em", textTransform: "uppercase",
          color: tab === t.k ? "var(--m-text)" : "var(--m-text-3)",
          borderBottom: tab === t.k ? "2px solid var(--m-primary)" : "2px solid transparent",
          cursor: "pointer",
        }}>
          <Icon name={t.i} size={11}/> {t.l}
        </div>
      ))}
    </div>

    <div style={{ flex: 1, padding: 16, overflow: "auto" }}>
      {tab === "tutor" && <>
        <div className="m-chip" style={{
          background: "rgba(155,184,106,0.10)", borderColor: "rgba(155,184,106,0.32)", color: "var(--m-positive)",
        }}>
          <Icon name="shield" size={10}/> Tutor educativo · sin recomendaciones
        </div>
        <div style={{ marginTop: 14 }}>
          <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", letterSpacing: "0.1em" }}>CONTEXTO · A3 · Soportes y resistencias</div>
          <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ padding: 12, borderRadius: 6, background: "rgba(216,168,104,0.06)", border: "1px solid rgba(216,168,104,0.2)" }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-accent)", letterSpacing: "0.1em" }}>TUTOR · profesor_analista</div>
              <div style={{ fontSize: 12.5, marginTop: 6, lineHeight: 1.4 }}>
                Antes de mirar volumen, ¿qué dice el <span style={{ color: "var(--m-accent)" }}>cierre</span> de la vela?
              </div>
            </div>
            <textarea placeholder="Tu respuesta (1-2 frases)" rows={3} style={{
              width: "100%", padding: 10, fontFamily: "var(--m-t-sans)", fontSize: 12,
              background: "var(--m-bg-deep)", border: "1px solid var(--m-line)", borderRadius: 4,
              color: "var(--m-text)", resize: "none",
            }} defaultValue=""/>
          </div>
        </div>

        <div style={{ marginTop: 14 }}>
          <MEye>Acciones rápidas</MEye>
          <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
            {[
              { i: "lightbulb", l: "Pista · 1/3" },
              { i: "help", l: "Otra pregunta" },
              { i: "book", l: "Más fácil" },
              { i: "ind", l: "Profundiza" },
            ].map((a, i) => (
              <button key={i} className="m-btn ghost sm" style={{ justifyContent: "flex-start", padding: "0 10px" }}>
                <Icon name={a.i} size={11}/> {a.l}
              </button>
            ))}
          </div>
        </div>

        <div className="m-divider" style={{ margin: "16px 0" }}/>
        <MEye>Hint ladder</MEye>
        <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
          {[
            { l: "nudge", c: "var(--m-accent)", t: "Fíjate en lo que ocurre tras la vela marcada." },
            { l: "specific", c: "var(--m-text-3)", t: "(bloqueado tras intento)" },
            { l: "worked example", c: "var(--m-text-3)", t: "(bloqueado tras intento)" },
          ].map((h, i) => (
            <div key={i} style={{ display: "flex", gap: 8, padding: "6px 8px", borderLeft: `2px solid ${h.c}`, background: "rgba(0,0,0,0.2)" }}>
              <span className="mono" style={{ fontSize: 9.5, color: h.c, letterSpacing: "0.08em", textTransform: "uppercase" }}>{i+1} · {h.l}</span>
            </div>
          ))}
        </div>
      </>}

      {tab === "source" && <ExplicaSourceTab/>}
      {tab === "gloss" && <ExplicaGlossaryTab/>}
    </div>
  </div>
);

export const ExplicaSourceTab = () => (
  <>
    <MEye>Fuente</MEye>
    <div style={{ marginTop: 10, fontFamily: "var(--m-t-mono)", fontSize: 11, color: "var(--m-text-2)", display: "flex", flexDirection: "column", gap: 4 }}>
      <div><span style={{ color: "var(--m-text-3)" }}>publisher</span>  vendor_primary</div>
      <div><span style={{ color: "var(--m-text-3)" }}>dataset</span>    DB.market_ohlcv</div>
      <div><span style={{ color: "var(--m-text-3)" }}>símbolo</span>    XYZ · 1D</div>
      <div><span style={{ color: "var(--m-text-3)" }}>ventana</span>    últimas 200 sesiones</div>
      <div><span style={{ color: "var(--m-text-3)" }}>retrieved</span>  2026-05-17 · 14:32 UTC</div>
      <div><span style={{ color: "var(--m-text-3)" }}>license</span>    tier_2 · uso educativo</div>
    </div>
  </>
);

export const ExplicaGlossaryTab = () => (
  <>
    <input placeholder="Buscar término…" style={{
      width: "100%", padding: 8, background: "var(--m-bg-deep)",
      border: "1px solid var(--m-line)", borderRadius: 4, color: "var(--m-text)", fontSize: 12,
    }}/>
    <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
      {[
        { t: "Resistencia", d: "Zona donde antes apareció oferta o frenó el avance del precio. No es una línea exacta." },
        { t: "Cierre confirmado", d: "Vela que cierra (no solo cruza) fuera de la zona, en el timeframe relevante." },
        { t: "Volumen relativo", d: "Volumen comparado con su media móvil; mide convicción." },
      ].map((g, i) => (
        <div key={i} style={{ padding: 10, background: "var(--m-bg-deep)", border: "1px solid var(--m-line)", borderRadius: 4 }}>
          <div className="mono" style={{ fontSize: 10, color: "var(--m-accent)", letterSpacing: "0.08em", textTransform: "uppercase" }}>{g.t}</div>
          <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 4, lineHeight: 1.4 }}>{g.d}</div>
        </div>
      ))}
    </div>
  </>
);

// Topbar elements shared
export const ExplicaTopbarExtras = ({ time = "02:14 / 07:00" }) => (
  <>
    <MRenderModeSwitcher mode="movie"/>
    <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>{time}</span>
  </>
);

export const ExplicaShell = ({ label, act = 3, center, right = <ExplicaRight tab="tutor"/>, sourceProps }) => (
  <div className="m-screen-d materia" data-screen-label={label}>
    <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
      <MRail active="map"/>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <div className="m-topbar">
          <div className="m-breadcrumb">
            <span>EducaFinaz</span><span className="sep">/</span>
            <span>Educa</span><span className="sep">/</span>
            <span>Explica</span><span className="sep">/</span>
            <span className="now">SUPPORT_RESISTANCE_BREAKOUTS</span>
          </div>
          <div style={{ flex: 1, display: "flex", justifyContent: "center", gap: 12, alignItems: "center" }}>
            <MRenderModeSwitcher mode="movie"/>
          </div>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <MChip variant="copper">EXPLICA · medio · 7 min</MChip>
            <MChip variant="live">live case</MChip>
            <button className="m-iconbtn"><Icon name="more" size={15}/></button>
          </div>
        </div>

        <div style={{ flex: 1, display: "flex", minHeight: 0 }}>
          <div style={{ width: 280, borderRight: "1px solid var(--m-line)", display: "flex", flexDirection: "column", background: "rgba(0,0,0,0.18)" }}>
            <ExplicaLeft act={act}/>
          </div>
          <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
            {center}
          </div>
          <div style={{ width: 360, borderLeft: "1px solid var(--m-line)", display: "flex", flexDirection: "column", background: "rgba(0,0,0,0.18)" }}>
            {right}
          </div>
        </div>
        <MSourceRail {...sourceProps}/>
      </div>
    </div>
  </div>
);

// ──────────────────────────────────────────────────────────
// 01 · Intro
// ──────────────────────────────────────────────────────────
export const ScreenMExplicaIntro = () => (
  <ExplicaShell
    label="Explica · Intro · 3-pane"
    act={1}
    sourceProps={{ source: "vendor_primary · XYZ 1D · evidence bundle EVB-217", note: "Pregunta guía declarada · render movie por defecto" }}
    center={
      <div style={{ flex: 1, overflow: "auto", padding: "32px 48px", display: "flex", flexDirection: "column" }}>
        <MEye>Capítulo 04 · Soportes, resistencias y rupturas</MEye>
        <h1 className="m-serif" style={{ fontSize: 56, fontWeight: 600, lineHeight: 1.0, letterSpacing: "-0.03em", margin: "12px 0 14px", fontStyle: "normal" }}>
          Ruptura o<br/><em style={{ color: "var(--m-accent)" }}>falsa ruptura</em>.
        </h1>
        <div style={{ fontSize: 17, color: "var(--m-text-2)", maxWidth: 700, lineHeight: 1.45, textWrap: "pretty" }}>
          La trampa más común del análisis técnico no es la ruptura: es <em>creer</em> que algo se ha roto.
        </div>

        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 24, alignItems: "start" }}>
          <div className="m-panel" style={{ padding: 22 }}>
            <MEye>Pregunta guía</MEye>
            <div style={{ fontSize: 21, marginTop: 10, lineHeight: 1.3, letterSpacing: "-0.01em" }}>
              ¿Cómo distingo una ruptura sólida de una <span style={{ color: "var(--m-accent)" }}>falsa ruptura</span>?
            </div>
            <div className="m-divider" style={{ margin: "20px 0" }}/>
            <MEye>En 7 minutos serás capaz de</MEye>
            <ol style={{
              listStyle: "none", padding: 0, marginTop: 12,
              display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10,
              counterReset: "obj",
            }}>
              {[
                "Dibujar soportes y resistencias como zonas",
                "Distinguir cruce, cierre y confirmación",
                "Usar volumen como evidencia",
                "Clasificar falsas rupturas sin sesgo",
              ].map((t, i) => (
                <li key={i} style={{
                  display: "flex", gap: 10, fontSize: 13, lineHeight: 1.35, textWrap: "pretty",
                  paddingLeft: 0, counterIncrement: "obj",
                }}>
                  <span className="mono" style={{ color: "var(--m-accent)", width: 22, flexShrink: 0, fontSize: 12 }}>0{i+1}</span>
                  <span>{t}</span>
                </li>
              ))}
            </ol>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div className="m-panel" style={{ padding: 16 }}>
              <MEye>Voz · profesor_analista</MEye>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 10 }}>
                <div style={{ width: 48, height: 48, borderRadius: 99, background: "radial-gradient(circle at 30% 30%, #d8a868, #c97a4b)", display: "grid", placeItems: "center" }}>
                  <Icon name="audio-wave" size={18} style={{ color: "#1c0e07" }}/>
                </div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>Carlos · profesor_analista</div>
                  <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", marginTop: 2 }}>density · medio</div>
                </div>
                <button className="m-btn ghost sm" style={{ marginLeft: "auto" }}>cambiar</button>
              </div>
            </div>
            <div className="m-misconception" style={{ padding: 14 }}>
              <div className="lbl">protege contra</div>
              <div style={{ fontSize: 13, fontWeight: 600, marginTop: 6 }}>cruce_visual_no_basta</div>
              <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 4, lineHeight: 1.4 }}>
                Tocar un nivel durante unos segundos no es romperlo.
              </div>
            </div>
            <div className="m-panel" style={{ padding: 14, background: "rgba(216,168,104,0.05)" }}>
              <MEye>Render mode</MEye>
              <div style={{ marginTop: 10 }}>
                <MRenderModeSwitcher mode="movie"/>
              </div>
              <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", marginTop: 8, letterSpacing: "0.06em" }}>cambia en cualquier momento · retorno exacto</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "auto", paddingTop: 24, display: "flex", alignItems: "center", gap: 14, justifyContent: "space-between" }}>
          <MNotAdvice>Educativo · no es asesoramiento · evidence bundle EVB-217 · v2.3</MNotAdvice>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="m-btn"><Icon name="book" size={13}/> Reading</button>
            <button className="m-btn"><Icon name="headset" size={13}/> Audio</button>
            <button className="m-btn primary lg" style={{ padding: "0 28px" }}><Icon name="play" size={14}/> Empezar</button>
          </div>
        </div>
      </div>
    }
  />
);

// ──────────────────────────────────────────────────────────
// Player center frame (used by Act/Freeze/Lab/Transfer)
// ──────────────────────────────────────────────────────────
export const ExplicaCenter = ({ act = "A3", title = "Aplicación en chart", question = "¿Qué confirmaría la ruptura?", chart, beats, time = "02:14 / 07:00" }) => (
  <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "20px 28px 0", minHeight: 0 }}>
    {/* Eyebrow + objective */}
    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
      <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.14em", textTransform: "uppercase" }}>Acto · {act} · {title}</span>
      <span style={{ flex: 1, height: 1, background: "var(--m-line)" }}/>
      <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>{time}</span>
    </div>
    <div className="m-objective" style={{ marginTop: 10 }}>
      <div>
        <div className="eye">Pregunta del usuario</div>
        <div className="text" style={{ marginTop: 2, fontSize: 14 }}>{question}</div>
      </div>
    </div>

    {/* Host visual */}
    <div style={{ marginTop: 14, flex: 1, minHeight: 0 }}>
      {chart}
    </div>

    {/* Beats below */}
    {beats && (
      <div style={{ padding: "12px 0", display: "flex", flexDirection: "column", gap: 6 }}>
        {beats}
      </div>
    )}

    {/* Chapter timeline + controls */}
    <div className="m-panel" style={{
      margin: "10px 0 14px", padding: "10px 14px",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>CAP</span>
        <div className="m-timeline" style={{ flex: 1 }}>
          {[1,2,3,4,5,6,7].map(i => (
            <div key={i} className={`act ${i < 3 ? "done" : i === 3 ? "now" : ""}`}/>
          ))}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <button className="m-iconbtn"><Icon name="back" size={12}/></button>
          <button className="m-iconbtn primary" style={{ background: "rgba(201,122,75,0.18)" }}><Icon name="pause" size={14}/></button>
          <button className="m-iconbtn"><Icon name="next" size={12}/></button>
          <button className="m-iconbtn"><Icon name="freeze" size={12}/></button>
          <button className="m-iconbtn"><Icon name="cc" size={12}/></button>
        </div>
      </div>
    </div>
  </div>
);

// ──────────────────────────────────────────────────────────
// 02 · Player / Act A3
// ──────────────────────────────────────────────────────────
export const ScreenMExplicaAct = () => (
  <ExplicaShell
    label="Explica · Player · Act A3"
    act={3}
    sourceProps={{ note: "EXPLICA · A3_guided_chart · density medium · ARCH.technical_analyst" }}
    center={
      <ExplicaCenter
        chart={
          <MChart width={700} height={380} caption="XYZ · 1D · price + volume + events"
            overlays={[
              { type: "zone", topPct: 24, bottomPct: 32, color: "copper", label: "ZONA R · 101.5 — 102.4" },
              { type: "marker", xPct: 70, yPct: 18, label: "cierre fuera", kind: "decision" },
              { type: "hline", yPct: 70, color: "rgba(216,196,160,0.3)", dashed: true, label: "S" },
              { type: "trend", from: [12, 80], to: [88, 30], color: "rgba(216,168,104,0.6)" },
            ]}/>
        }
        beats={
          <>
            {[
              { n: "01", c: "var(--m-primary)", t: "Zona R con 3 toques previos en últimas 40 sesiones" },
              { n: "02", c: "var(--m-positive)", t: "Cierre fuera de zona en 1D" },
              { n: "03", c: "var(--m-positive)", t: "Volumen relativo +60% sobre media móvil 20" },
            ].map((b, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span className="mono" style={{ fontSize: 11, color: b.c, letterSpacing: "0.08em", flexShrink: 0 }}>{b.n}</span>
                <span style={{ flex: 1, height: 1, background: `color-mix(in oklab, ${b.c} 30%, transparent)` }}/>
                <span style={{ fontSize: 13, color: "var(--m-text)" }}>{b.t}</span>
              </div>
            ))}
          </>
        }
      />
    }
  />
);

// ──────────────────────────────────────────────────────────
// 03 · Player / Freeze
// ──────────────────────────────────────────────────────────
export const ScreenMExplicaFreeze = () => (
  <ExplicaShell
    label="Explica · Freeze"
    act={3}
    sourceProps={{ time: "14:32 UTC · congelado", note: "Voz pausa · motion = 0 · return_point: resume_exact_scene_timecode" }}
    center={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "20px 28px 0", minHeight: 0 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <MChip variant="warn"><Icon name="freeze" size={10}/> congelado · 03:18</MChip>
          <span style={{ flex: 1, height: 1, background: "var(--m-line)" }}/>
          <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>valores con timestamp</span>
        </div>

        <div style={{ marginTop: 14, flex: 1, minHeight: 0, display: "grid", gridTemplateColumns: "1.8fr 1fr", gap: 16 }}>
          {/* Frozen chart with rim light */}
          <div style={{
            padding: 1, borderRadius: 10,
            background: "linear-gradient(135deg, rgba(216,168,104,0.7), rgba(201,122,75,0.5), rgba(216,168,104,0.15))",
          }}>
            <MChart width={448} height={384} caption="XYZ · 1D · 14:32 UTC · FIXED"
              overlays={[
                { type: "zone", topPct: 24, bottomPct: 32, color: "copper", label: "R · 101.5" },
                { type: "marker", xPct: 70, yPct: 18, label: "cierre", kind: "decision" },
              ]}/>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <MEye>Acciones contextuales</MEye>
            {[
              { i: "draw", t: "Dibujar zona" },
              { i: "tag",  t: "Etiquetar swings" },
              { i: "compare", t: "Comparar con caso similar" },
              { i: "play", t: "Replay vela a vela" },
              { i: "link", t: "Abrir fuente" },
              { i: "help", t: "Preguntar al tutor" },
              { i: "book", t: "Glosario · resistencia" },
              { i: "save", t: "Guardar para repaso" },
            ].map((a, i) => (
              <button key={i} className="m-panel" style={{
                padding: "10px 12px", display: "flex", alignItems: "center", gap: 10,
                fontSize: 12.5, color: "var(--m-text)", cursor: "pointer",
                background: "var(--m-metal-2)", textAlign: "left",
              }}>
                <Icon name={a.i} size={13} style={{ color: "var(--m-primary)" }}/>
                <span style={{ flex: 1 }}>{a.t}</span>
                <Icon name="next" size={11} style={{ color: "var(--m-text-3)" }}/>
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", padding: "16px 0", gap: 10 }}>
          <button className="m-btn ghost"><Icon name="x" size={13}/> Salir freeze</button>
          <button className="m-btn primary lg" style={{ flex: 1, padding: "0 24px" }}>
            <Icon name="play" size={14}/> Reanudar exactamente desde 03:18
          </button>
        </div>
      </div>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 04 · Player / Lab · Draw zone
// ──────────────────────────────────────────────────────────
export const ScreenMExplicaLab = () => (
  <ExplicaShell
    label="Explica · Lab · DrawZone"
    act={5}
    sourceProps={{ note: "EXPLICA · A5_misconception_lab · EX.draw_zone · IoU vs solución guía" }}
    center={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "20px 28px 0", minHeight: 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <MEye>LAB · ejercicio 3 de 4 · draw_zone</MEye>
          <div style={{ display: "flex", gap: 6 }}>
            <button className="m-btn ghost sm"><Icon name="retry" size={11}/> Rehacer</button>
            <button className="m-btn ghost sm"><Icon name="x" size={11}/> Limpiar</button>
            <button className="m-btn ghost sm"><Icon name="list" size={11}/> Alternativa accesible</button>
          </div>
        </div>

        <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 12 }}>
          <h2 style={{ fontSize: 22, fontWeight: 600, letterSpacing: "-0.015em", margin: 0, lineHeight: 1.2, flex: 1 }}>
            Dibuja la <span style={{ color: "var(--m-accent)" }}>zona de resistencia</span> más relevante.
          </h2>
        </div>

        {/* Toolbar */}
        <div className="m-panel" style={{ marginTop: 14, padding: 6, display: "flex", gap: 4 }}>
          {[
            { i: "draw", l: "Zona", on: true },
            { i: "tag",  l: "Etiqueta" },
            { i: "compare", l: "Comparar" },
            { i: "ind",  l: "Indicador" },
          ].map((b, i) => (
            <button key={i} className="m-btn ghost sm" style={{
              flex: 0, padding: "0 14px", height: 32,
              background: b.on ? "rgba(216,168,104,0.16)" : "transparent",
              borderColor: b.on ? "var(--m-accent)" : "transparent",
              color: b.on ? "var(--m-accent)" : "var(--m-text-2)",
            }}>
              <Icon name={b.i} size={12}/> {b.l}
            </button>
          ))}
          <span style={{ flex: 1 }}/>
          <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", padding: "0 8px", alignSelf: "center" }}>snap a swings · crosshair</span>
        </div>

        {/* Chart with user zone */}
        <div style={{ marginTop: 10, flex: 1, minHeight: 0, position: "relative" }}>
          <MChart width={680} height={340} caption="XYZ · 1D · tu zona dibujada"
            overlays={[
              { type: "zone", topPct: 22, bottomPct: 34, color: "default", label: "TU ZONA · 1.6 alto" },
              { type: "hline", yPct: 28, color: "rgba(216,168,104,0.7)", dashed: false },
            ]}/>
          <div style={{
            position: "absolute", right: 12, top: 88,
            fontFamily: "var(--m-t-mono)", fontSize: 10, color: "var(--m-accent)",
            background: "rgba(0,0,0,0.85)", padding: "2px 8px", borderRadius: 3,
            border: "1px solid rgba(216,168,104,0.45)",
          }}>102.4</div>
          <div style={{
            position: "absolute", right: 12, top: 124,
            fontFamily: "var(--m-t-mono)", fontSize: 10, color: "var(--m-accent)",
            background: "rgba(0,0,0,0.85)", padding: "2px 8px", borderRadius: 3,
            border: "1px solid rgba(216,168,104,0.45)",
          }}>100.8</div>
        </div>

        {/* Mini player + CTA */}
        <div style={{ marginTop: 14, marginBottom: 14, display: "flex", gap: 12, alignItems: "center" }}>
          <div className="m-panel" style={{ flex: 1, padding: "8px 12px", display: "flex", alignItems: "center", gap: 10 }}>
            <Icon name="pause" size={14} style={{ color: "var(--m-text-2)" }}/>
            <div style={{ flex: 1, height: 3, background: "rgba(216,196,160,0.12)", borderRadius: 2, overflow: "hidden" }}>
              <div style={{ width: "57%", height: "100%", background: "var(--m-text-2)" }}/>
            </div>
            <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>04:02 / 07:00</span>
          </div>
          <button className="m-btn ghost"><Icon name="lightbulb" size={13}/> Pista 1/3</button>
          <button className="m-btn accent lg"><Icon name="check" size={14}/> Enviar zona</button>
        </div>
      </div>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 05 · Transfer · UnseenChart (submitted)
// ──────────────────────────────────────────────────────────
export const ScreenMExplicaTransfer = () => (
  <ExplicaShell
    label="Explica · Transferencia"
    act={6}
    sourceProps={{ note: "EXPLICA · A6_transfer_practice · unseen chart · rubric 80%" }}
    center={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "20px 28px 0", minHeight: 0, overflow: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <MChip variant="live">transferencia</MChip>
          <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>gráfico no visto · aplica lo aprendido</span>
        </div>

        <h2 style={{ fontSize: 24, fontWeight: 600, marginTop: 12, lineHeight: 1.2, letterSpacing: "-0.02em" }}>
          ¿Hay <span style={{ color: "var(--m-accent)" }}>ruptura</span>, espera o falsa?
        </h2>

        <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 18, alignItems: "start" }}>
          <div>
            <MChart width={520} height={300} caption="ABC · 1D · sin overlays"
              overlays={[
                { type: "zone", topPct: 26, bottomPct: 34, color: "default", label: "tu zona" },
                { type: "marker", xPct: 70, yPct: 22, label: "ruptura", kind: "decision" },
              ]}/>
          </div>
          <div className="m-feedback-correct" style={{ padding: 18 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Icon name="check" size={16} style={{ color: "var(--m-positive)" }}/>
              <span className="mono" style={{ fontSize: 11, color: "var(--m-positive)", letterSpacing: "0.14em", textTransform: "uppercase" }}>Transferencia válida · 80% rubric</span>
            </div>
            <div style={{ fontSize: 14, marginTop: 10, lineHeight: 1.4, textWrap: "pretty" }}>
              Has integrado <span style={{ color: "var(--m-positive)" }}>nivel + cierre + volumen</span>. Misconception evitada: cruce ≠ ruptura.
            </div>
            <div style={{ marginTop: 12 }}>
              <MEye>Rubric</MEye>
              <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
                {[
                  { l: "nivel", on: true },
                  { l: "cierre", on: true },
                  { l: "volumen", on: true },
                  { l: "contexto", on: false },
                ].map((r, i) => (
                  <span key={i} className="m-chip" style={{
                    background: r.on ? "rgba(155,184,106,0.14)" : "rgba(216,196,160,0.06)",
                    borderColor: r.on ? "rgba(155,184,106,0.4)" : "var(--m-line)",
                    color: r.on ? "var(--m-positive)" : "var(--m-text-3)",
                  }}>
                    <Icon name={r.on ? "check" : "circle"} size={9}/> {r.l}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
          <div className="m-panel" style={{ padding: 16 }}>
            <MEye>Confianza declarada</MEye>
            <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ flex: 1 }}>
                <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>ANTES</div>
                <div style={{ display: "flex", gap: 4, marginTop: 6 }}>
                  {[0,1,2,3,4].map(i => (
                    <span key={i} style={{ width: 18, height: 18, borderRadius: 3, background: i < 2 ? "var(--m-text-2)" : "rgba(216,196,160,0.12)" }}/>
                  ))}
                </div>
              </div>
              <Icon name="next" size={16} style={{ color: "var(--m-accent)" }}/>
              <div style={{ flex: 1 }}>
                <div className="mono" style={{ fontSize: 10, color: "var(--m-accent)" }}>DESPUÉS</div>
                <div style={{ display: "flex", gap: 4, marginTop: 6 }}>
                  {[0,1,2,3,4].map(i => (
                    <span key={i} style={{ width: 18, height: 18, borderRadius: 3, background: i < 4 ? "var(--m-accent)" : "rgba(216,196,160,0.12)" }}/>
                  ))}
                </div>
              </div>
              <div className="m-serif" style={{ fontSize: 30, color: "var(--m-positive)", lineHeight: 1, fontStyle: "normal" }}>+2</div>
            </div>
          </div>
          <div className="m-panel" style={{ padding: 16 }}>
            <MEye>Tu razonamiento</MEye>
            <div style={{ marginTop: 8, fontSize: 12.5, color: "var(--m-text-2)", lineHeight: 1.4, padding: 10, background: "rgba(0,0,0,0.25)", borderRadius: 4, fontStyle: "italic" }}>
              “Cierre por encima de zona R con volumen relativo alto; la falsa ruptura habría dejado el cierre dentro.”
            </div>
          </div>
        </div>

        <div style={{ marginTop: "auto", padding: "16px 0 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button className="m-btn"><Icon name="retry" size={13}/> Reintentar</button>
          <button className="m-btn primary lg"><Icon name="next" size={14}/> Siguiente · Recap</button>
        </div>
      </div>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 06 · Recap / EndCard
// ──────────────────────────────────────────────────────────
export const ScreenMExplicaRecap = () => (
  <ExplicaShell
    label="Explica · Recap"
    act={7}
    sourceProps={{ note: "EXPLICA completado · spaced_recall programado · próximo nodo recomendado" }}
    center={
      <div style={{ flex: 1, padding: "32px 48px", display: "flex", flexDirection: "column", overflow: "auto" }}>
        <MEye>Resumen · 3 tarjetas</MEye>
        <h1 className="m-serif" style={{ fontSize: 42, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.025em", margin: "10px 0 4px", fontStyle: "normal" }}>
          Ruptura o <em style={{ color: "var(--m-accent)" }}>falsa ruptura</em>.
        </h1>
        <div style={{ fontSize: 15, color: "var(--m-text-2)", marginTop: 6 }}>7 actos · 4 ejercicios · 1 transferencia · 80% mastery</div>

        <div style={{ marginTop: 24, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
          {[
            { lbl: "CONCEPTO", c: "var(--m-primary)", t: "Soporte y resistencia son zonas, no líneas exactas.", icon: "graph" },
            { lbl: "EVIDENCIA", c: "var(--m-positive)", t: "Cierre + volumen relativo + contexto sostienen la ruptura.", icon: "check" },
            { lbl: "CAUTELA",   c: "var(--m-warn)",   t: "Cruce ≠ ruptura. La confirmación llega tras el cierre.", icon: "shield" },
          ].map((c, i) => (
            <div key={i} className="m-panel" style={{ padding: 22, borderTop: `2px solid ${c.c}` }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="mono" style={{ fontSize: 10.5, color: c.c, letterSpacing: "0.14em" }}>{c.lbl}</div>
                <Icon name={c.icon} size={14} style={{ color: c.c }}/>
              </div>
              <div style={{ fontSize: 15, marginTop: 14, lineHeight: 1.35, textWrap: "pretty" }}>{c.t}</div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 22, display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 18 }}>
          <div className="m-panel" style={{ padding: 18, border: "1px solid rgba(201,122,75,0.4)" }}>
            <MEye>Próximo nodo</MEye>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 12 }}>
              <div style={{ width: 56, height: 56, borderRadius: 8, background: "rgba(201,122,75,0.18)", display: "grid", placeItems: "center" }}>
                <Icon name="ind" size={22} style={{ color: "var(--m-primary)" }}/>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 18, fontWeight: 600, letterSpacing: "-0.01em" }}>Volatilidad · ATR y Bollinger</div>
                <div className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)", marginTop: 4 }}>EXPLICA · 7 min · prerequisitos cumplidos</div>
              </div>
              <button className="m-btn primary"><Icon name="next" size={13}/> Continuar</button>
            </div>
          </div>
          <div className="m-panel" style={{ padding: 18 }}>
            <MEye>Repaso programado</MEye>
            <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
              {[
                { d: "mañana", t: "1 flashcard", i: "spark" },
                { d: "día 4", t: "micro-quiz", i: "list" },
                { d: "día 10", t: "transfer", i: "target" },
              ].map((s, i) => (
                <div key={i} style={{ flex: 1, padding: 10, borderRadius: 4, background: "var(--m-bg-deep)", border: "1px solid var(--m-line)" }}>
                  <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.1em", color: "var(--m-text-3)" }}>{s.d.toUpperCase()}</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6 }}>
                    <Icon name={s.i} size={12} style={{ color: "var(--m-accent)" }}/>
                    <span style={{ fontSize: 11.5 }}>{s.t}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    }
  />
);
